<template>
  <section id="intro">
    <div class="container">
      <div class="row">
        <div align="left" class="col-sm-12 col-md-8">
          <div class="intro-content">
            <h2>List Commercial {{ salesType }} Property</h2>
            <p>List the perfect commercial property</p>
          </div>
        </div>
      </div>
    </div>

    <carousel
      :nav="false"
      :dots="false"
      :items="1"
      :autoplay="true"
      :loop="true"
      id="intro-carousel"
      style="margin-top:-50px"
      :responsive="{ 0: { items: 1, nav: false }, 600: { items: 1, nav: false } }"
    >
      <img class="item" src="img/intro-carousel/comm-1.jpg" alt="" />
      <img class="item" src="img/intro-carousel/comm-2.jpg" alt="" />
      <img class="item" src="img/intro-carousel/comm-3.jpg" alt="" />
      <img class="item" src="img/intro-carousel/comm-4.jpg" alt="" />
      <img class="item" src="img/intro-carousel/comm-5.jpg" alt="" />
      <img class="item" src="img/intro-carousel/comm-6.jpg" alt="" />
    </carousel>

    <div id="intro-carousel" class="owl-carousel"></div>
  </section>
</template>

<script>
/* eslint-disable */
import carousel from "vue-owl-carousel";

export default {
  components: {
    carousel
  },
  props: ["salesType"]
};
</script>

<style lang="scss" scoped></style>
